"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertModelToOverride = void 0;
const ModelOverride_1 = require("../objects/ModelOverride");
function convertModelToOverride(keyVal, model) {
    if (!model) {
        throw new Error("Model is undefined");
    }
    const modelOverride = new ModelOverride_1.ModelOverride();
    modelOverride.modelId = keyVal.key;
    modelOverride.position.x = model.position.x;
    modelOverride.position.y = model.position.y;
    modelOverride.position.z = model.position.z;
    modelOverride.rotation.x = model.rotation.x;
    modelOverride.rotation.y = model.rotation.y;
    modelOverride.rotation.z = model.rotation.z;
    modelOverride.scale.x = model.scale.x;
    modelOverride.scale.y = model.scale.y;
    modelOverride.scale.z = model.scale.z;
    return modelOverride;
}
exports.convertModelToOverride = convertModelToOverride;
